export const mapViewToTranslationKey = {
  'No. Samples': 'sampleCount',
  'Resistance prevalence': 'resistancePrevalence',
  'Genotype prevalence': 'genotypePrevalence',
  'ST prevalence': 'stPrevalence',
  'Lineage prevalence (ST)': 'lineagePrevalence',
  // shige: the 'Lincode prevalence' view is presented as 'Genotype prevalence'
  // (it is the genotype mapped from the LINcode) — keep the plot title consistent.
  'Lincode prevalence': 'genotypePrevalence',
  'LIN code prevalence': 'linCodePrevalence',
  'NG-MAST prevalence': 'ngmastPrevalence',
  'Serotype prevalence': 'serotypePrevalence',
  'Pathotype prevalence': 'pathotypePrevalence',
  'Geographic Comparisons': 'geographicComparisons',
  'Serotype Comparisons': 'serotypeComparisons',
  'O prevalence': 'oPrevalence',
  'H prevalence': 'hPrevalence',
  'Dominant Genotype': 'dominantGenotype',
  'H58 / Non-H58': 'h58NonH58',
  MDR: 'mdr',
  Pansusceptible: 'pansusceptible',
  XDR: 'xdr',
  Azithromycin: 'azithromycin',
  Ciprofloxacin: 'ciprofloxacin',
  CipR: 'cipR',
  ESBL_category: 'esblCategory',
  Ceftriaxone: 'ceftriaxone',
  ESBL: 'esbl',
  Carbapenems: 'carbapenems',
  CipNS: 'cipNS',
};
